// Property endpoint functions. Async, call `sellerApi`, throw `AppError` (mapped
// by the interceptor), and return DTOs — the parser runs in the query hook.
//
// All reads: the seller has no property write path (admin-service owns the
// property lifecycle), so there are no mutations in this module.
import { sellerApi } from '@core/api/httpClient'
import { propertyEndpointPaths } from './propertyEndpointPaths'
import type {
  ApiEnvelope,
  PaginatedEnvelope,
  PortfolioStatusDto,
  PropertyDetailDto,
  PropertyListDto,
  PropertySummaryDto,
} from './propertyContracts'

// Query params accepted by the paginated list endpoint. No status filter: the
// server deliberately does not offer one (the seller scope and the page window
// live on the listing-request side, the stage on the property side).
export interface GetPropertiesParams {
  page: number
  limit: number
}

export async function getProperties(params: GetPropertiesParams): Promise<PropertyListDto> {
  const { data } = await sellerApi.get<PaginatedEnvelope<PropertySummaryDto>>(
    propertyEndpointPaths.PROPERTIES,
    { params: { page: params.page, limit: params.limit } },
  )
  return { items: data.data, pagination: data.pagination }
}

export async function getProperty(id: string): Promise<PropertyDetailDto> {
  const { data } = await sellerApi.get<ApiEnvelope<PropertyDetailDto>>(
    propertyEndpointPaths.property(id),
  )
  return data.data
}

export async function getPortfolioStatus(): Promise<PortfolioStatusDto> {
  const { data } = await sellerApi.get<ApiEnvelope<PortfolioStatusDto>>(
    propertyEndpointPaths.PORTFOLIO_STATUS,
  )
  return data.data
}
